import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { Spinner } from "../../components/Spinner";
import { easeCurves } from "../eases";
import React from 'react';
import styled from 'styled-components';
export function LoadingContainer(_ref) {
  var isLoading = _ref.isLoading,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$mountTransitionC = _ref.mountTransitionComplete,
      mountTransitionComplete = _ref$mountTransitionC === void 0 ? true : _ref$mountTransitionC,
      spinnerDelay = _ref.spinnerDelay,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["isLoading", "size", "mountTransitionComplete", "spinnerDelay", "children"]);

  var renderChildren = !isLoading && mountTransitionComplete;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FadeIn, _extends({
    $visible: renderChildren
  }, other), renderChildren && children), /*#__PURE__*/React.createElement(Spinner, {
    centered: true,
    delay: spinnerDelay,
    size: size,
    isLoading: isLoading && mountTransitionComplete
  }));
}
var FadeIn = styled.div.withConfig({
  displayName: "LoadingContainer__FadeIn",
  componentId: "vapor__sc-1qtm79u-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;transition:opacity 0.3s ", ";", ""], easeCurves.primary, function (p) {
  return !p.$visible ? "\n    opacity: 0;\n    pointer-events: none;\n  " : "\n    opacity: 1;\n    pointer-events: auto;\n  ";
});